import React from 'react';

import Routes from './Routes';

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;



// // class App extends Component {
//   const App = (props) => {
//   // render() {
//     return (
//       <React.Fragment>
        
//       </React.Fragment>
//     );
//   }
// // }

// export default withRouter(App);



// import Panda from './Compon/Panda';
// import Gorilla from './Compon/Gorilla';
// import Rhino from './Compon/Rhino';
// import SeaTurtle from './Compon/SeaTurtle';
// import Homes from './Compon/Homes';

// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import Navigation from './Compon/Navigation';
// import React, { Component } from 'react';

// export default class App extends Component{
//   render(){
//     return (   
//       <React.Fragment>
//         <Router>
//           <div className = "App">
//               <Navigation/>         
//                 <Switch>                
//                   <Route path='/panda' component={Panda}/>  
//                   <Route path='/gorilla' component={Gorilla}/>               
//                   <Route path='/rhino' component={Rhino}/> 
//                   <Route path='/seaTurtle' component={SeaTurtle}/>  
//                   <Route path='/' component={Homes}/>     
        
//                   <Route exact path='/' component={Homes}/>       
//                 </Switch>
//           </div>  
//         </Router>
//        </React.Fragment>        
//     );
//   }

// }
